import React from "react";
import { Link,Outlet } from "react-router-dom";
import { useMemo, useState } from 'react';
import { useSelector,useDispatch } from "react-redux";
import { ReLottery,Lottery } from "./counterSlice";
import './App.css';


// --------------------------HomePage---------------------------
export function Qualified(){


    const dispatch =useDispatch()
    const [name,setName]=useState("Name");
    const [number,setnumber]=useState("Number");

    return(
        <div>
            <h1>🧀Cheese🧀</h1>
            姓名：<input className = "input" type="textbox"  value={name} onChange={(e)=>{setName(e.target.value)}}></input>
            <br /><br />
            學號：<input className = "input" type="textbox" value={number} onChange={(e)=>{setnumber(e.target.value)}}></input>
            <br /><br /><br />
            
            <Link to ="result"><button className="button-86" onClick={()=>dispatch(Lottery({"name":name,"number":number}))} >Lottery</button></Link>        
        </div>        
    );
}

export function Home(){
    return(
        <div>
            <Qualified/>
            
        </div>
    )
}


// --------------------------Result---------------------------
function Reward(){
    const value =useSelector((state)=>state.counter.value)
    const value2 =useSelector((state)=>state.counter.value2)
    const name =useSelector((state)=>state.counter.name)
    const dispatch =useDispatch()
  
    const list=["頭獎","一獎","二獎","三獎","四獎","五獎",
    "六獎","七獎","八獎","九獎","十獎",]

    const ans = useMemo(() => {
        return list[Math.floor(Math.random()*10)];
      }, [value2]);

    return(
        <div>
            <h2>🧀Cheese🧀</h2>
            <h2>🎉{value}{name}🎉</h2>
            <h1 style={{color:'red'}}>{ans}</h1>
            <button className="button-89" onClick={()=>dispatch(ReLottery())}>ReLottery</button>
            <br />
        </div>
    )
}

export function Result(){
    return(
        <div>
            <Reward/>
            <Link to ="/"><h3>HomePage</h3></Link>
            <Outlet/>
        </div>
    )
}